import React from "react";
import { Draggable } from "react-beautiful-dnd";
import PersonIcon from "@material-ui/icons/Person";
import { getDriverInfo } from "../../../utils/helpers";
import ListViewItem from "../../accountDrawer/ListViewItem";

export default function DriverDragItem({
  item,
  checkAssigned,
  index,
  inputValue,
  editDriver,
  isSelected,
  handleSelect = () => null,
}) {
  const getItemStyle = (isDragging, draggableStyle, index) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: "none",
    backgroundColor: "#F9F9F9",
    // styles we need to apply on draggables
    ...draggableStyle
  });

  return (
    <Draggable key={item.id} draggableId={item.id} index={index}>
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          style={getItemStyle(
            snapshot.isDragging,
            provided.draggableProps.style,
            index
          )}
          data-cy="driverDraggableItem"
        >
          <ListViewItem
            key={getDriverInfo(item, "id")}
            CustomIcon={({ ...props }) => (
              <PersonIcon fontSize="small" {...props} />
            )}
            checkAssigned={checkAssigned}
            handleSelect={handleSelect}
            isSelected={isSelected}
            label={"driver"}
            getInfo={getDriverInfo}
            item={item}
            inputValue={inputValue}
            handleEdit={editDriver}
            index={index}
          />
        </div>
      )}
    </Draggable>
  );
}
